import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon-o-attention.svg'


const _withScopeId = n => (_pushScopeId("data-v-aa03c714"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-left":"2px","transform":"translateY(2px)"},
  src: _imports_0
}, null, -1))

import { ref, reactive, computed, watch, } from 'vue';
import { ElMessage } from 'element-plus';
import { useI18n } from 'vue-i18n';
import { resetPassword } from '../loginApi'
import { passwordVerify } from '@/utils/index'
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswords',
  props: {
  visible: { type: Boolean, required: true, default: false },
  title: { type: String, required: false, default: '' },
  code: { type: Boolean, required: false, default: false },
  codeParams: { type: String, required: false, default: '3' },
  // loading: { type: Boolean, required: false, default: false },
  userId: { type:String }
},
  emits: ['update:visible', 'handleSave'],
  setup(__props, { emit }) {

const props = __props;

const { t } = useI18n();
const store = useStore();
const getLanguageValue = computed(() => store.getters.getLanguageValue);


const fromList = reactive<{
  label: string
  value: string
  placeholder?: string
  tipLabel?: string
  maxlength?: number
}[]>([
  {
    label: t('login.newPassword'),
    maxlength: 20,
    tipLabel: t('login.passwordStrengthTip'),
    value: ''
  },
  {
    label: t('login.confirmPassword'),
    maxlength: 20,
    value: ''
  },
  {
    label: t('login.yourPassword'),
    value: '',
    placeholder: t('login.yourPlaceholder'),
  },
])

const dialogShow = computed({
  get: () => props.visible,
  set: (val: boolean) => emit('update:visible', val),
});
watch(() => dialogShow.value, (newData:any) => {
  if (newData) {
    fromList[0].value = ''
    fromList[1].value = ''
    fromList[2].value = ''
  }
})
const loading = ref(false)
const handleSave = () => {
  const newPassword = fromList[0].value
  if (passwordVerify(newPassword)) return ElMessage.error(passwordVerify(newPassword))
  let obj = {
    newPassword: fromList[0].value,
    confirmPassword: fromList[1].value,
    currentPassword: fromList[2].value,
    userId: props.userId
  }
  loading.value = true
  resetPassword(obj).then((res:any) => {
    dialogShow.value = false
    ElMessage.success(res.resultMessage)
  }).finally(()=>loading.value = false)
};


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogShow).value = $event)),
    title: props.title,
    width: "720px",
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fromList, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "from",
          key: i
        }, [
          _createElementVNode("span", {
            style: _normalizeStyle({width:getLanguageValue.value==='en'?'180px':'130px'})
          }, [
            _createTextVNode(_toDisplayString(item.label) + " ", 1),
            (item.tipLabel)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  content: item.tipLabel,
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 2
                }, 1032, ["content"]))
              : _createCommentVNode("", true)
          ], 4),
          _createVNode(_component_el_input, {
            modelValue: fromList[i].value,
            "onUpdate:modelValue": ($event: any) => ((fromList[i].value) = $event),
            class: "w-50 m-2 inputbox",
            size: "large",
            maxlength: fromList[i].maxlength,
            placeholder: item.placeholder||_ctx.$t('login.input') + item.label.toLowerCase(),
            type: 'text',
            "show-password": ""
          }, null, 8, ["modelValue", "onUpdate:modelValue", "maxlength", "placeholder"])
        ]))
      }), 128)),
      _createElementVNode("div", {
        class: "enter",
        onClick: handleSave
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t('login.confirm')), 1),
        (loading.value)
          ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0,
              class: "el-icon is-loading",
              style: {"margin-left":"5px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Loading)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})